// extracted by mini-css-extract-plugin
export default {"paginate":"NeovarsityManagementPagination_paginate__ZVQQ1"};